import axios from 'axios'

const url = import.meta.env.VITE_API_URL_BASE


export const axiosClient = axios.create({
  baseURL: url || 'https://api-cashfit.tecnologiagrupoopus.com.br/cashfit/v1/'
})
